#import "../../../../graphql/fragments/sales-automation-stageset.graphql"

mutation UpdateAccountAssignmentAutomation(
    $automation: UpdateClosedLeadAccountTypeAutomationInputFieldInput!
) {
    updateClosedLeadAccountTypeAutomation(input: {closedLeadAccountTypeAutomation: $automation}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
